import { call, put, takeLatest, select, takeEvery, all } from "redux-saga/effects";

import {
  apiGetJournalTable, apiGetJournalTableExport, apiGetJournalTableLog,
  apiGetJournalTablePracticeAccounting, apiGetJournalTableView,
  apiGetSdotByMark,
  apiGetSdotByMarkCurrent,
  apiGetTestResultByStudent,
  apiPerformance
} from "./api";
import {
  getGetPerformance,
  getGetPerformanceDone,
  getGetPerformanceFail,
  getGetSdotByMark,
  getGetSdotByMarkCurrent,
  getGetSdotByMarkCurrentDone,
  getGetSdotByMarkCurrentFail,
  getGetSdotByMarkDone,
  getJournalCurrentCtpListAction,
  getJournalCurrentCtpListActionDone,
  getJournalCurrentCtpListActionFail,
  getGetSdotByMarkFail,
  getGetStudentPerformance,
  getJournalCurrentAction,
  getJournalListAction,
  getJournalListActionDone,
  getJournalListActionFail,
  getJournalTableAction,
  getJournalTableActionDone,
  getJournalTableActionFail,
  postJournalLessonAction,
  postJournalLessonActionFail,
  setMarkSdotType,
  setMarkSdotTypeDone,
  setMarkSdotTypeFail,
  setRateTaskResult,
  setRateTaskResultDone,
  setRateTaskResultFail,
  setTestResultByStudent,
  setTestResultByStudentDone,
  setTestResultByStudentFail,
  getJournalCurrentFilterActionDone,
  getJournalCurrentFilterActionFail,
  getJournalCurrentFilterAction,
  getJournalTableInnerView,
  getJournalTableInnerViewDone,
  getJournalTableInnerViewFail,
  journalTableExport,
  journalTableExportDone,
  journalTableExportFail,
  journalTableLogDone,
  journalTableLogFail, journalTableLog,
} from "./actions";
import { PayloadAction } from "@reduxjs/toolkit";

import { apiSetForm } from "../../common/api";
import { IJournalTable, IJournalType } from "./types";
import { getOneCtpFlow, getOneLessonFlow } from "../plans/saga";
import { getPeriodFlow } from "../../common/saga";
import { RootState } from "../../index";
import { selectStore } from "../../selector";
import { apiCtpTypes } from "../plans/api";
import { JOURNAL_YEAR } from "../../../constants";
import { t } from "i18next";
import { getPeriodActionDone } from "../../common/actions";
import { DEPUTY_TYPES } from "../../../constants/roles";

function* getJournalListFlow({ payload }: PayloadAction<IJournalType>): any {
  const { profile: { userProfile: userProfileState } }: RootState = yield select(selectStore)

  const isDirectorDeputy = userProfileState.data?.roles?.some((item: any) => {
    return DEPUTY_TYPES.find((el: any) => el === item)
  })

  const years = [
    JOURNAL_YEAR.PREV,
    JOURNAL_YEAR.CURRENT,
    JOURNAL_YEAR.NEXT,
  ]

  const commonType = [
    {
      key: `filter-type-1`,
      name: 'filter',
      value: 'my',
      label: t('common:private'),
      url: 'ctp',
    },
    {
      key: `filter-type-2`,
      name: 'filter',
      value: 'curator',
      label: t('common:curator'),
      url: 'ctp',
    }
  ]

  const adminType = [
    {
      key: `filter-type-1`,
      name: 'filter',
      value: 'my',
      label: t('common:private'),
      url: 'ctp',
    },
    {
      key: `filter-filter-4`,
      name: 'filter',
      value: 'all',
      label: t('common:all'),
      filter_url: 'ctp-filter',
      url: 'ctp',
    }
  ]

  try {
    const yearsData = yield all(years?.map((item: any) => {
      return call(apiCtpTypes, { year: item })
    }))

    if (yearsData) {
      let res = years?.map((first: any, firstIndex: any) => {
        return {
          label: `${first}-${Number(first) + 1}`,
          key: `year-${first}-${firstIndex}`,
          name: 'year',
          value: first,
          secondValue: Number(first) + 1,
          children: yearsData[firstIndex]?.data?.map((second: any, secondIndex: any) => {
            return {
              label: second.label,
              key: `type-${second.value}-${secondIndex}`,
              name: 'type',
              value: second.value,
              children: userProfileState.data?.isCollegeAdmin || isDirectorDeputy ? adminType : commonType
            }
          })
        }
      })

      yield put(getJournalListActionDone(res))
    }

  } catch (e) {
    console.warn(e);
    yield put(getJournalListActionFail());
  }
}

function* getJournalCurrentCtpListFlow({ payload }: PayloadAction<IJournalType>): any {
  try {
    const data = yield call(apiSetForm, payload);
    if (data.data) {
      yield put(getJournalCurrentCtpListActionDone(data.data));
    }
  } catch (e) {
    console.error(e);
    yield put(getJournalCurrentCtpListActionFail(payload));
  }
}

function* getJournalCurrentCtpFilterFlow({ payload }: PayloadAction<any>): any {
  const isDone = payload.success
  const isFail = payload.failed

  if (isDone) {
    yield put(getJournalCurrentFilterActionDone(payload?.data))
  }

  if (isFail) {
    yield put(getJournalCurrentFilterActionFail(payload))
  }
}

function* getJournalTableFlow({ payload }: PayloadAction<IJournalTable>): any {
  try {
    const data = yield call(apiGetJournalTable, payload);
    if (data.data) {
      yield put(getJournalTableActionDone(data.data));
    }
  } catch (e) {
    console.error(e);
    yield put(getJournalTableActionFail(payload));
  }
}

function* postJournalLessonFlow({ payload }: PayloadAction<any>): any {
  const isDone = payload.success
  const isFail = payload.failed

  if (isDone) {
    let body = {
      ctp_id: payload.data.ctp_id,
      ...(payload.data.start_date ? { start_date: payload.data.start_date } : {}),
      ...(payload.data.end_date ? { end_date: payload.data.end_date } : {}),
      ...(payload.data.tab ? { tab: payload.data.tab } : {}),
      ...(payload.data.month ? { month: payload.data.month } : {}),
    }
    // @ts-ignore
    yield call(getJournalTableFlow, { payload: body })
  }

  if (isFail) {
    yield put(postJournalLessonActionFail(payload))
  }
}

function* getPerformanceFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiPerformance, payload);
    if (data.data) {
      yield put(getGetPerformanceDone(data.data));
    }
  } catch (e) {
    yield put(getGetPerformanceFail());
  }
}

function* getSdotResultByMarkFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiGetSdotByMark, payload);
    if (data.data) {
      yield put(getGetSdotByMarkDone(data.data));
    }
  } catch (e) {
    yield put(getGetSdotByMarkFail());
  }
}

function* getSdotResultByMarkCurrentFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiGetSdotByMarkCurrent, payload);
    if (data.data) {
      yield put(getGetSdotByMarkCurrentDone(data.data));
    }
  } catch (e) {
    yield put(getGetSdotByMarkCurrentFail());
  }
}

function* setRateTaskResultFlow({ payload }: PayloadAction<any>): any {
  const isDone = payload.success
  const isFail = payload.failed

  if (isDone) {
    yield put(setRateTaskResultDone(payload))
    // @ts-ignore
    yield call(getSdotResultByMarkCurrentFlow, { payload: payload.data })
  }

  if (isFail) {
    yield put(setRateTaskResultFail(payload))
  }
}


function* setMarkSdotTypeFlow({ payload }: PayloadAction<any>): any {
  const isDone = payload.success
  const isFail = payload.failed

  if (isDone) {
    yield put(setMarkSdotTypeDone(payload))

    // @ts-ignore
    yield call(getOneLessonFlow, { payload: { lesson_id: payload?.data?.lesson_id, student_id: payload?.data?.student_id } })
  }

  if (isFail) {
    yield put(setMarkSdotTypeFail(payload))
  }
}

function* getTestResultByStudentFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiGetTestResultByStudent, payload);
    if (data.data) {
      yield put(setTestResultByStudentDone(data.data));
    }
  } catch (e) {
    yield put(setTestResultByStudentFail());
  }
}

function* getJournalCurrentFlow({ payload }: PayloadAction<any>): any {
  try {
    // @ts-ignore
    let ctp = yield call(getOneCtpFlow, { payload: payload })
    // @ts-ignore
    let periodByGroup = yield call(getPeriodFlow, { payload: { year: ctp?.year, group_id: ctp?.group_id } })

    let tabs = [
      {
        id: 'subject',
        name: 'Итоговые оценки',
        active: false,
        params: {
          ctp_id: payload,
          tab: 'subject'
        }
      },
      {
        id: 'module',
        name: 'Итоги по модулю',
        active: false,
        params: {
          ctp_id: payload,
          tab: 'module'
        }
      }
    ]

    if (periodByGroup?.length) {
      yield put(getPeriodActionDone([...periodByGroup?.map((item: any) => ({
        ...item,
        params: {
          end_date: item.end_date,
          start_date: item.start_date,
          ctp_id: payload
        }
      })), ...tabs]));

    } else {
      // @ts-ignore
      let period = yield call(getPeriodFlow, { payload: { year: ctp?.year } })
      yield put(getPeriodActionDone([...period?.map((item: any) => ({
        ...item,
        params: {
          end_date: item.end_date,
          start_date: item.start_date,
          ctp_id: payload
        }
      })), ...tabs]));

    }

  } catch (e) {

  }
}

function* getGetStudentPerformanceFlow({ payload }: PayloadAction<any>): any {
  const { profile: { userProfile: userProfileState } }: RootState = yield select(selectStore)

  try {
    // @ts-ignore
    let periodByGroup = yield call(getPeriodFlow, { payload: { group_id: userProfileState.data?.group_id, year: payload } })

    if (periodByGroup?.length) {

    } else {
      // @ts-ignore
      let period = yield call(getPeriodFlow, { payload: { year: payload } })

    }

  } catch (e) {

  }
}

function* getJournalTableInnerViewFlow({ payload }: PayloadAction<any>): any {
  try {
    let data: any

    switch (payload.type) {
      case '3':
        data = yield call(apiGetJournalTablePracticeAccounting, payload.body);
        break
      case '0':
      case '4':
        data = yield call(apiGetJournalTableView, payload.body);
        break
    }
    if (data.data) {
      yield put(getJournalTableInnerViewDone(data.data));
    }
  } catch (e) {
    yield put(getJournalTableInnerViewFail());
  }
}

function* journalTableExportFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiGetJournalTableExport, payload);
    if (data.data) {
      window.open(data.data?.link, "_blank")
      yield put(journalTableExportDone(data.data));
    }
  } catch (e) {
    yield put(journalTableExportFail());
  }
}

function* journalTableLogFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiGetJournalTableLog, payload);
    if (data.data) {
      yield put(journalTableLogDone(data.data));
    }
  } catch (e) {
    yield put(journalTableLogFail());
  }
}



export default function* journalSaga() {
  // @ts-ignore
  yield takeEvery(getJournalListAction, getJournalListFlow);
  yield takeEvery(getJournalCurrentCtpListAction, getJournalCurrentCtpListFlow);
  yield takeEvery(getJournalCurrentFilterAction, getJournalCurrentCtpFilterFlow);

  yield takeEvery(getJournalTableAction, getJournalTableFlow);

  yield takeLatest(postJournalLessonAction, postJournalLessonFlow);
  yield takeLatest(getGetPerformance, getPerformanceFlow);
  yield takeLatest(getGetSdotByMark, getSdotResultByMarkFlow);
  yield takeLatest(getGetSdotByMarkCurrent, getSdotResultByMarkCurrentFlow);
  yield takeLatest(setRateTaskResult, setRateTaskResultFlow);
  yield takeLatest(setMarkSdotType, setMarkSdotTypeFlow);
  yield takeLatest(setTestResultByStudent, getTestResultByStudentFlow);
  yield takeLatest(getJournalCurrentAction, getJournalCurrentFlow);
  yield takeLatest(getGetStudentPerformance, getGetStudentPerformanceFlow);
  yield takeLatest(getJournalTableInnerView, getJournalTableInnerViewFlow);
  yield takeLatest(journalTableExport, journalTableExportFlow);
  yield takeLatest(journalTableLog, journalTableLogFlow);
}
